import { Pipe, PipeTransform } from '@angular/core';

import { PackagingFormat } from '@mtna/rds-packaging-ui';

import { RdsChip } from '../chips/index';

/**
 * Turn `PackagingFormat`s into RdsChips
 * @author Will Davis <will.davis@mtna.us>
 */
@Pipe({
  name: 'rdsFormatChips'
})
export class RdsFormatChipsPipe implements PipeTransform {
  transform(value: Array<PackagingFormat>): Array<RdsChip> {
    if (!value || !value.length) {
      return [];
    }
    return value.map(f => new RdsChip(f.name, f.id));
  }
}
